import React from 'react';
import { RadioGroup, FormControlLabel, Radio, Button, Stack } from '@mui/material';

const WithholdingModalActions = ({
    t,
    direction,
    reportingWay,
    setReportingWay,
    handleDownloadPdf,
    withholdingContentRef,
    handleSaveWithholdingTaxReport,
    onClose,
    isSubordinateClient
}) => {
    return (
        <div className="wht-modal-actions">
            <div className="wht-modal-actions__buttons">
                <Button
                    variant="contained"
                    onClick={() => handleDownloadPdf(withholdingContentRef)}
                    sx={{
                        background: 'linear-gradient(135deg, #304FFF 0%, #5a73ff 100%)',
                        borderRadius: '8px',
                        px: 3, py: 0.8,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '13px',
                        boxShadow: '0 2px 8px rgba(48, 79, 255, 0.25)',
                        '&:hover': { background: 'linear-gradient(135deg, #2a45e0 0%, #4d65f0 100%)' }
                    }}
                >
                    {t('DownloadPDFFile')}
                </Button>
            </div>

            <div className="wht-modal-actions__reporting">
                <RadioGroup
                    row
                    value={reportingWay}
                    onChange={(e) => setReportingWay(e.target.value)}
                    className="wht-modal-actions__radio-group"
                >
                    <FormControlLabel
                        value="automatic"
                        control={<Radio size="small" sx={{ color: '#304FFF', '&.Mui-checked': { color: '#304FFF' } }} />}
                        label={<span className="wht-modal-actions__radio-label">{t('AutomaticTaxAuthorityReporting')}</span>}
                        disabled={isSubordinateClient}
                    />
                    <FormControlLabel
                        value="manual"
                        control={<Radio size="small" sx={{ color: '#304FFF', '&.Mui-checked': { color: '#304FFF' } }} />}
                        label={<span className="wht-modal-actions__radio-label">{t('ManualReporting')}</span>}
                        disabled={isSubordinateClient}
                    />
                    <FormControlLabel
                        value="unreported"
                        control={<Radio size="small" sx={{ color: '#304FFF', '&.Mui-checked': { color: '#304FFF' } }} />}
                        label={<span className="wht-modal-actions__radio-label">{t('Unreported')}</span>}
                    />
                </RadioGroup>
            </div>

            <div className="wht-modal-actions__footer">
                <button
                    className="wht-modal-actions__report-btn"
                    onClick={handleSaveWithholdingTaxReport}
                    disabled={isSubordinateClient}
                >
                    {t('Report')}
                </button>
                <button className="wht-modal-actions__close-btn" onClick={onClose}>
                    {t('close')}
                </button>
            </div>
        </div>
    );
};

export default WithholdingModalActions;
